import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../../api';
import Cookies from 'universal-cookie';
import showLoader from 'src/components/loader';
import { useConfirm } from '../../components/ConfirmDialog';
const cookies = new Cookies();

const PaymentHistory = () => {
  const confirm = useConfirm();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});

  useEffect(() => {
    fetchPayments();
  }, []);

  const fetchPayments = async (page = 1) => {
    try {
      const response = await axios.get(`${API_URL}/api/payments/admin/payments?page=${page}&limit=10`, {
        headers: {
          Authorization: cookies.get('TOKEN'),
        },
      });
      console.log(response);
      setPayments(response.data.data);
      setPagination({
        totalPages: response.data.data.totalPages,
        currentPage: response.data.data.currentPage,
        total: response.data.data.total
      });
    } catch (error) {
      console.error('Error fetching payments:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRefund = async (paymentId) => {
    if (await confirm({ title: 'Refund payment', message: 'Are you sure you want to refund this payment?', confirmLabel: 'Refund', danger: true })) {
      try {
        await axios.post('/api/payments/admin/refund', 
          { paymentId },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('adminToken')}`
            }
          }
        );
        alert('Refund processed successfully');
        fetchPayments();
      } catch (error) {
        alert('Refund failed: ' + error.response.data.error);
      }
    }
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      succeeded: 'success',
      pending: 'warning',
      failed: 'danger',
      refunded: 'secondary'
    };
    
    return <span className={`badge badge-${statusColors[status]}`}>{status}</span>;
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="payments-admin">
      <h2>Payment Management</h2>
      
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Customer</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                  <th>Payment Method</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {payments.map(payment => (
                  <tr key={payment._id}>
                    <td>{payment._id}</td>
                    <td>
                      {payment.user?.name || 'Guest'}
                      <br />
                      <small>{payment.user?.email}</small>
                    </td>
                    <td>${payment.amount}</td>
                    <td>{getStatusBadge(payment.status)}</td>
                    <td>{new Date(payment.createdAt).toLocaleDateString('en-GB')}</td>
                    <td>{payment.paymentMethod || 'N/A'}</td>
                    <td>
                      <button 
                        className="btn btn-info btn-sm mr-2"
                        onClick={() => window.open(payment.receiptUrl, '_blank')}
                        disabled={!payment.receiptUrl}
                      >
                        Receipt
                      </button>
                      {payment.status === 'succeeded' && (
                        <button 
                          className="btn btn-warning btn-sm"
                          onClick={() => handleRefund(payment._id)}
                        >
                          Refund
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="pagination">
            <button 
              disabled={pagination.currentPage === 1}
              onClick={() => fetchPayments(pagination.currentPage - 1)}
            >
              Previous
            </button>
            
            <span>Page {pagination.currentPage} of {pagination.totalPages}</span>
            
            <button 
              disabled={pagination.currentPage === pagination.totalPages}
              onClick={() => fetchPayments(pagination.currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentHistory;
